// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/PingFang Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/PingFang Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Medium */
@font-face {
    font-family: 'PingFangSCMedium';
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

/* Regular */
@font-face {
    font-family: 'PingFangSCRegular';
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,+DAA2D;AAC/D;;AAEA,YAAY;AACZ;IACI,gCAAgC;IAChC,gBAAgB;IAChB,+DAA4D;AAChE","sourcesContent":["/* Medium */\n@font-face {\n    font-family: 'PingFangSCMedium';\n    font-weight: 500;\n    src: url('../fonts/PingFang Medium.ttf') format('truetype');\n}\n\n/* Regular */\n@font-face {\n    font-family: 'PingFangSCRegular';\n    font-weight: 500;\n    src: url('../fonts/PingFang Regular.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
